module.exports = __webpack_public_path__ + "static/pic04-521c38909eb50f2c50b350c9cb4a35ba.jpg";